import React from 'react';
import * as yup from 'yup';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { api } from '@api';
import { useIncidentCreation } from '@hooks/incidents';
import { useCustomTranslations } from '@hooks/useCustomTranslations';
import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';

import { IncidentFormWrapper } from '../IncidentFormWrapper';

export const PaymentsSecurityDepositReturnForm = ({
  customTranslations,
}: ParsedEntry<IWidget>) => {
  const { t, tContentful } = useCustomTranslations(customTranslations);

  const { create } = useIncidentCreation({
    postIncident: api.incidents.postGenericIncident,
    classifications: {
      classification: IncidentClassification.RENTALPAYMENT_STATUS,
      subClassification: IncidentSubClassification.RENT_GUARANTEE_RETURN,
    },
  });

  return (
    <IncidentFormWrapper<{ files: File[] }>
      incidentKind="PaymentsSecurityDepositReturn"
      withFileUpload
      defaultValues={{
        files: [],
      }}
      validationSchema={yup.object().shape({
        files: yup
          .array()
          .min(1, t('fileInputError'))
          .files(tContentful)
          .required(),
      })}
      onSubmit={(values) => create({ ...values, title: t('messageTitle') })}
    />
  );
};
